import React, { Component } from 'react';

import { colors } from '../../../theme/tokens';

// Kept for the files that import them; the values live in theme/tokens.ts
export const titleBlue = colors.titleBlue;
export const dividerBlue = colors.dividerBlue;
export const primaryBlue = colors.primary;
export const subtitleGrey = colors.subtitleGrey;
export const cardsTextDark = colors.textDark;
export const cardsTextGrey = colors.textGrey;

const SharedStyle = {
    innerContent: {
        marginTop: '55px',
        marginLeft: '50px', 
    },
    contentCardDefault: {
        alignItems:"center",
        border: '2px solid #585D724D',
        borderRadius:'8px',
        cursor: "pointer",
    },
    contentCardSelected: {
        alignItems:"center",
        border: '2px solid #3179FF',
        borderRadius:'8px',
        cursor: "pointer",
    }
};

export default SharedStyle;